<template>
  <div class="main-container">
    <!--使用响应式布局-->
    <el-row v-loading.fullscreen.lock="loading" element-loading-text="努力加载中">
      <!--控制页面宽度-->
      <el-col :xs="24" :sm="24" :md="{ span: 24, offset: 0 }" :lg="{ span: 24, offset: 0 }"
        :xl="{ span: 24, offset: 0 }">
        <el-row :gutter="20" style="margin-left: 0; margin-right: 0;">

          <!--目录-->
          <!-- <el-col :class="(mobile && deviceWidth < 1200)?'directory-panel':'directory-panel-fixed'" v-if="directory.length > 0" :xs="24" :sm="24" :md="24" :lg="4" :xl="4"> -->
          <el-col :class="directoryClass" v-if="directory.length > 0" :xs="24" :sm="24" :md="24" :lg="4" :xl="4">
            <el-card>
              <!--目录-->
              <div>
                <h3 style="margin: 0;">目录</h3>
                <el-divider class="thin-divider"></el-divider>
                <div v-for="item in directory" :key="item.name"
                  :style="{ marginLeft: (item.tagId - 2 < 0 ? 0 : item.tagId - 2) * 20 + 'px', fontSize: 22 - (item.tagId * 2) + 'px' }">
                  <a @click="scrollToPosition(item.href)" class="directory">{{ item.name }}</a>
                </div>
              </div>
            </el-card>
          </el-col>

          <!--正文-->
          <el-col v-if="article" :xs="24" :sm="24" :md="24" :lg="{ span: 16, offset: offset }"
            :xl="{ span: 16, offset: offset }">
            <!-- 若目录不使用fixed，则使用下面这个样式 -->
            <!-- <el-col v-if="article" v-loading="loading" :xs="24" :sm="24" :md="24" :lg="{span:16, offset: directory.length?0:4}" :xl="{span:16, offset: directory.length?0:4}"> -->
            <el-card style="margin-bottom: 10px">
              <!--页头-->
              <div class="header">
                <!--标题-->
                <div class="title">
                  {{ article.title }}
                </div>
                <!--基本信息-->
                <div>
                  <span class="hover"><i class="el-icon-user-solid"></i>{{ article.author }}</span>
                  <span>{{ article.updateTime }}</span>
                  <span><i class="el-icon-view"></i>{{ article.viewNum }}</span>
                </div>
                <!--标签-->
                <div style="color: #474545">
                  <span><i class="el-icon-menu"></i>{{ article.categoryName }}</span>
                  <i class="iconfont icon-tags" style="font-size: 16px; margin-left: 10px">
                    <template v-for="(item, index) in article.tagsList">
                      <el-tag :key="index" size="mini" effect="dark" :color="randomHexColors[index]"
                        :style="{ 'margin-left': '10px', 'border-color': randomHexColors[index] }">
                        {{ item.tagName }}
                      </el-tag>
                    </template>
                  </i>
                </div>
              </div>
            </el-card>

            <!--正文-->
            <div class="content">
              <!--<v-md-preview :text="article.content" @copy-code-success=""></v-md-preview>-->
              <!--由于预览时对正文内容进行了自定义处理（代码块显示行号、有复制按钮等，处理结果为html格式），所以如果配置上:html="false"属性会导致没有预览效果-->
              <!--如果关闭了html，则需要配置:xssOptions="false"，否则控制台会报错；
            如果没关闭html，则不建议关闭xssOption，否则文章里的html代码会直接渲染到页面上（Script脚本没有被渲染到页面，但好像也没有被执行）
            但是，在这里由于对正文做了处理，返回是html，所以要么关闭xss(:xssOptions="false")，要么配置xss白名单(:xssOptions="xssOptions")来过滤标签和属性，否则处理后的内容会b被拦截，导致页面渲染异常。
            -->
              <!-- on 20250620 mavon-editor中使用了window对象，而ssr在服务端没有window对象，
             所以这里先不在服务端渲染正文内容，只渲染标题。
             后面需要改动：在写完文章保存的时候，把渲染后的内容也存到数据库，
             这里就直接读取数据库中渲染好的内容，而不再通过mavon-editor在浏览器渲染。 -->
              <mavon-editor v-if="isClient" :value="content" :toolbarsFlag="false" :imageClick="clickImage()"
                :subfield="false" defaultOpen="preview" navigation :xssOptions="false"
                codeStyle="tomorrow-night-bright" />
              <!--<el-image :src="currentClickedImageUrl[0]" :preview-src-list="currentClickedImageUrl"></el-image>-->
              <!--el-image预览时使用的内部组件，导入进来单独使用，否则没办法不点击el-image的图片就打开预览-->
              <!--<el-image-viewer v-if="showViewer" :on-close="closeViewer" :url-list="currentClickedImageUrlArr" />-->
              <!--这个会在鼠标滚轮缩放图片时，页面也会滚动-->
              <!--<el-image-viewer v-if="showViewer" :on-close="closeViewer" :url-list="[currentClickedImageUrl]" />-->
              <!--这个好用-->
              <el-image ref="image__preview" style="display: none;" :src="currentClickedImageUrl"
                :preview-src-list="[currentClickedImageUrl]"></el-image>
            </div>
            <el-divider></el-divider>

            <!--点赞收藏分享-->
            <div class="operate">
              <div class="operate-item" @click="dianzan()">
                <i class="iconfont icon-dianzan" ref="dianzan"></i>
                <span class="size24">{{ likeNum }}</span>
              </div>
              <div class="operate-item" @click="collect()">
                <i class="iconfont icon-collect" ref="collect"></i>
                <span class="size24">{{ collectionNum }}</span>
              </div>
              <div class="operate-item" title="点击复制链接分享" @click="share()">
                <i class="iconfont icon-share"></i>
              </div>
            </div>
            <el-divider></el-divider>

            <!--评论区-->
            <div>
              <span class="title">评论</span><span class="size24">{{ commentNum }}</span>
              <div v-if="!isLogin" style="width: 100%; text-align: center;">
                你需要 <a style="color: deepskyblue; cursor: pointer;" @click="toLogin()">登录</a> 后才能评论
              </div>
              <div style="display: flex; margin-top: 10px;">
                <el-avatar v-if="isLogin" :src="avatar"
                  style="cursor: pointer; height: 3rem; width: 3.5rem;"></el-avatar>
                <el-input v-model="comment" ref="input" :disabled="!allowComment" type="textarea" :maxlength="1000"
                  show-word-limit :autosize="{ minRows: 2, maxRows: 20 }"
                  :placeholder="article.allowComment === 0 ? '评论区不是无人区哦' : '该文章没有开放评论'"></el-input>
                <div style="display: flex; flex-direction: column; justify-content: flex-end">
                  <el-button :loading="submitLoading" type="primary" :disabled="!comment || !allowComment"
                    @click="submit()">发布</el-button>
                </div>
              </div>
              <div class="comment">
                <el-empty v-if="commentTreeList.length === 0" description="还没有评论"></el-empty>
                <div v-else>
                  <div v-for="(item, index) in commentTreeList" :key="index">
                    <Comment :item="item" :user-id="article.articleId" :allow-comment="article.allowComment"></Comment>
                  </div>
                </div>
              </div>
            </div>
          </el-col>
          <el-col v-else :xs="24" :sm="24" :md="24" :lg="{ span: 16, offset: offset }"
            :xl="{ span: 16, offset: offset }">
            <el-empty description="笔记不见了，看看别的吧">
            </el-empty>
          </el-col>
          <!--最近文章-->
          <el-col :class="recentListClass" style="margin-bottom: 20px" :xs="24" :sm="24" :md="24" :lg="4" :xl="4">
            <el-card>
              <h3 style="margin: 0;">最近文章</h3>
              <el-divider class="thin-divider"></el-divider>
              <!-- @click="viewArticle(item.articleId)" -->
              <router-link v-for="item in recentArticleList" :key="item.articleId"
                :to="{ name: 'ArticleDetail', params: { articleId: item.articleId } }" target="_blank">
                <div class="recentList">
                  <el-tooltip :content="item.title" effect="light" :open-delay="500">
                    <div class="text-overflow">{{ item.title }}</div>
                  </el-tooltip>
                  <div style="font-size: 12px;">
                    分类:<b>{{ item.categoryName }}</b>浏览:<b>{{ item.viewNum }}</b>
                  </div>
                </div>
              </router-link>
            </el-card>
          </el-col>

        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {
  getArticleDetailById,
  getLikeStatus,
  increaseArticleViewsNum,
  likeArticle
} from "@/api/articles";
import { getArticleList } from "@/api/articles";
import { commentArticle, getArticleCommentList } from "@/api/comment";
import { getRandomCoolHexColor } from "@/utils/randomColor";
import Comment from "@/components/Comment";
import { mavonEditor } from 'mavon-editor'
import 'mavon-editor/dist/css/index.css'
import $ from 'jquery';
import { markdown } from "@/utils/markdown";
import Clipboard from "clipboard"

export default {
  name: "Detail",
  components: {
    Comment,
    mavonEditor,
    // 导入el-image的大图预览组件，并手动触发（预览时鼠标滚轮缩放图片会导致页面滚动，大图的初始比例不对，需要手动点击切换显示比例）：https://blog.csdn.net/qq_44712405/article/details/105836883
    // 或者（好用，不需要手动导入预览组件，直接使用el-image即可，class="no-show"）https://www.cnblogs.com/code-R/p/16831540.html
    // 'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer')
  },
  data() {
    return {
      loading: false,
      articleId: null,
      article: {},
      content: '',
      directory: [],
      randomHexColors: [],
      likeNum: 0,
      collectionNum: 0,
      comment: '',
      commentTreeList: [],
      commentNum: 0,
      // 通过 whiteList 来指定，格式为：{'标签名': ['属性1', '属性2']}。不在白名单上 的标签将被过滤，不在白名单上的属性也会被过滤。
      xssOptions: {
        whiteList: {
          a: ['id', 'href', 'title', 'target'],
          b: ['id', 'class', 'style'],
          br: [],
          button: ['id', 'style', 'class', 'type', 'data-clipboard-action', 'data-clipboard-target'],
          code: ['id', 'class'],
          div: ['id', 'class', 'style', 'title'],
          em: [],
          h1: ['id', 'class', 'style'],
          h2: ['id', 'class', 'style'],
          h3: ['id', 'class', 'style'],
          h4: ['id', 'class', 'style'],
          h5: ['id', 'class', 'style'],
          h6: ['id', 'class', 'style'],
          hr: [],
          i: ['id', 'class', 'style'],
          img: ['id', 'src', 'alt'],
          label: ['id', 'class', 'style'],
          li: [],
          link: ['id', 'href'],
          ol: [],
          option: ['id', 'class', 'style'],
          p: ['id', 'class', 'style'],
          pre: ['id', 'class', 'style'],
          select: ['id', 'class', 'style'],
          span: ['id', 'style', 'aria-hidden', 'class'],
          strong: [],
          textarea: ['id', 'style', 'class'],
          table: ['id', 'class', 'style'], th: [], tr: [], td: [],
          ul: ['id', 'class'],
        }
      },
      showViewer: false,
      // 预览图片数组，未使用，直接使用[imgUrl]获取即可
      currentClickedImageUrlArr: [],
      currentClickedImageUrl: '',
      like: false,
      collected: false,
      submitLoading: false,
      clipboard: null,
      timer: undefined,
      // 初始化默认值，仅用于SSR
      deviceWidth: 1200,
      // 标记是否为客户端
      isClient: false,
      // 标记是否为 SSR
      SSR: false,
      // 最近文章列表
      recentArticleList: [],
      // 调试模式
      debug: false
    }
  },
  asyncData(context) {
    const articleId = context.route.params.articleId;
    return getArticleDetailById(articleId).then(res => {
      // 将数据注入到组件上下文中（context），供模板使用。
      // 将数据保存到 store 中
      // console.log("articleDetailPage: asyncData() set article to storoe. articleId =", articleId)
      context.store.commit('ssr/SET_ARTICLE', res.data)
      if (res.data) {
        const title = res.data.title;
        const description = res.data.articleAbstract;
        let keywords = res.data.title;
        if (res.data.tagsList.length > 0) {
          keywords = res.data.tagsList.map(tag => tag.tagName).join(',');
        }
        context.store.dispatch('ssr/setMetaTitle', title)
        context.store.commit('ssr/SET_META_DESCRIPTION', description)
        context.store.commit('ssr/SET_META_KEYWORDS', keywords)
      } else {
        context.store.dispatch('ssr/setMetaTitle', '风铃笔记')
      }
      context.meta = {
        keywords: res.data.tagsList.map(tag => tag.tagName).join(','),
        description: res.data.articleAbstract || '风铃笔记文章详情'
      }
    }).catch((err) => {
      console.log(err);
      return Promise.reject(err);
    });
  },
  created() {
    // this.articleId = this.$route.query.articleId;
    this.articleId = this.$route.params.articleId;
    // console.log('route.params.articleId', this.articleId);

    if (this.isBrowser()) {
      this.log('created isBrowser')
      // 如果store中有数据
      if (this.$store.state.ssr.article && this.$store.state.ssr.article.articleId) {
        this.log('store存在文章详情', this.$store.state.ssr.article);
        // 判断文章id是否一致
        if (Number(this.articleId) == this.$store.state.ssr.article.articleId) {
          this.log('store的文章id和当前一致，赋值给article');
          // 一致则赋值给article
          this.article = this.$store.state.ssr.article;
          this.likeNum = this.article.likeNum
          this.SSR = true;
        } else {
          this.log('store的文章id和当前不一致，重新获取', this.articleId);
          this.getArticleDetail();
        }
      } else {
        this.log('store不存在文章详情，重新获取', this.articleId);
        this.getArticleDetail();
      }

      this.getArticleCommentList();
      this.log('browser created end');
    } else {
      this.log('非浏览器环境，created中不执行操作');
      this.log('in server created end');
    }
  },
  // mounted()函数只会在浏览器端执行，所以涉及到dom的操作，都放在mounted()函数中
  mounted() {
    this.$nextTick(() => {
      // 执行前做销毁判断，避免多次监听。
      let clipboard = new Clipboard('.copy-btn');
      this.clipboard = clipboard
      clipboard.on('success', () => {
        this.$modal.msgSuccess('复制成功')
      });
      clipboard.on('error', () => {
        this.$modal.msgError('复制失败')
      });
    });

    this.isClient = true;
    // 设置初始值
    this.deviceWidth = window.innerWidth;

    // 如果是SSR获取到的数据，则在这里设置文章相关的数据
    if (this.SSR) {
      this.log('mounted() in browser. this.SSR=', this.SSR);
      this.log('mounted() in browser. this.articleId=', this.articleId);
      this.log('mounted() in browser. this.article=', this.article);
      if (this.article && this.article.articleId) {
        this.setDocumentTitle(this.article.title);
        this.content = markdown(mavonEditor, this.article.content);
        this.getRandomHexColor();
        this.createDirectory();
        if (this.isLogin) {
          this.getLikeStatus();
        }
        this.increaseViewNum();
      }
    }

    // 获取最近文章
    this.recentArticleList = this.$store.getters.recentArticleList;
    if (!this.recentArticleList || this.recentArticleList.length === 0) {
      this.getArticleList();
    }

    // 监听窗口大小变化
    // console.log('articleDetailPage: mounted() addEventListener');
    window.addEventListener('resize', this.handleResizeChange);
  },
  beforeDestroy() {
    if (this.isBrowser()) {
      window.removeEventListener('resize', this.handleResizeChange);
    }
    // 移除剪切板对象，避免on 事件监听回调多次执行
    if (this.clipboard) {
      this.clipboard.destroy()
    }
    if (this.timer) {
      clearTimeout(this.timer)
    }
  },
  metaInfo() {
    return {
      title: this.$store.state.ssr.pageTitle || this.article.title || '文章详情',
      meta: [
        {
          name: 'keywords',
          content: this.$store.state.ssr.metaKeywords || this.article.title
        },
        {
          name: 'description',
          content: this.$store.state.ssr.pageDescription || this.metaDescriptionContent
        }
      ]
    }
  },
  computed: {
    directoryClass() {
      return this.deviceWidth < 1200 ? 'directory-panel' : 'directory-panel-fixed';
    },
    recentListClass() {
      return this.deviceWidth < 1200 ? 'recentList-panel' : 'recentList-panel-fixed';
    },
    metaDescriptionContent() {
      // 使用正则表达式匹配代码块
      const codeBlockPattern = /```[\s\S]*?```/g;
      return this.article.content?.replace(codeBlockPattern, '[code]').replaceAll('*', '').replaceAll('#', '').replaceAll('\n', '').replaceAll(' ', '');
    },
    title() {
      return this.article ? this.article.title : '笔记不见了';
    },
    isLogin() {
      return this.$store.getters.name !== '';
    },
    allowComment() {
      return this.isLogin && this.article.allowComment === 0;
    },
    avatar() {
      return this.$store.getters.avatar;
    },
    mobile() {
      // console.log(this.$store.getters.mobile)
      let value = this.$store.getters.mobile;
      // console.log(`mobile: ${value}`)
      return value;
    },
    // deviceWidth() {
    //   let width = window.innerWidth;
    //   // console.log(`width: ${width}`)
    //   return width;
    // },
    offset() {
      // let value = (this.mobile && this.deviceWidth < 1200) ? 0 : 4;
      let value = (this.deviceWidth < 1200) ? 0 : 4;
      // console.log(`offset: ${value}`)
      return value;
    },
  },
  watch: {
    // 监听路由参数变化，更新数据
    $route(newVal) {
      this.articleId = newVal.query.articleId;
      this.getArticleDetail();
      this.getArticleCommentList();
    }
  },
  methods: {
    log(message, ...optionalParams) {
      if (this.debug) {
        console.log(message, optionalParams);
      }
    },
    // 查询最近文章
    getArticleList() {
      const queryParams = { pageNum: 1, pageSize: 10 };
      getArticleList(queryParams).then(res => {
        this.recentArticleList = res.data.rows;
        this.$store.dispatch('article/setRecentArticleList', res.data.rows);
        this.$store.dispatch('article/setTotal', res.data.total);
      }).catch(() => { });
    },
    isBrowser() {
      return typeof window !== 'undefined';
    },
    handleResizeChange() {
      // 更新窗口宽度
      this.deviceWidth = window.innerWidth;
      // console.log(this.deviceWidth, 'innerWidth');
      // console.log(document.body.clientWidth, 'clientWidth');
    },
    viewArticle(articleId) {
      this.$router.push({
        path: '/detail',
        query: {
          articleId
        }
      }).catch(() => { })
    },
    toLogin() {
      this.$router.push('/login')
    },
    // 查询文章详情
    getArticleDetail(articleId) {
      if (!articleId) {
        articleId = this.articleId;
      }
      this.loading = true;
      getArticleDetailById(articleId).then(res => {
        this.article = res.data;
        this.likeNum = this.article.likeNum
        this.setDocumentTitle(this.article.title);
        // this.content = res.data.content;
        this.content = markdown(mavonEditor, res.data.content);
        // console.log(this.content)
        this.getRandomHexColor();
        this.createDirectory();
        if (this.isLogin) {
          this.getLikeStatus();
        }
        this.increaseViewNum();
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },
    // 设置页面标题
    setDocumentTitle(title) {
      document.title = title;
    },
    // 生成目录
    createDirectory() {
      this.$nextTick(() => {
        const aArr = $('.v-note-wrapper .v-note-panel .v-note-navigation-wrapper .v-note-navigation-content a').toArray();
        let directory = [];
        aArr.forEach(item => {
          let id = $(item).attr('id');
          let name = $(item).parent().text().replace('\n', '');
          const newId = '#' + id
          $(newId).attr('id', '_' + name);
          let href = '_' + name;
          let tagId = $(item).parent()[0].tagName.substring(1);
          // 选择有id属性的
          if (!id) {
            return
          }
          // if (!href) {
          //   return
          // }
          let directoryItem = {
            href: '#' + href,
            name: name,
            tagId
          }
          directory.push(directoryItem);
        })
        this.directory = directory;
      });
    },
    // 文章目录跳转
    scrollToPosition(id) {
      // let position = $(id).offset();
      // 解决id="with a space" 存在空格导致不发选中的问题
      id = id.replace('#', '')
      id = "[id='" + id + "']"
      let position = $(id).offset();
      // 减去header的高度
      position.top -= 60;
      // 滚动，由于我这里的滚动条是在el-main上，所以滚动对象为el-main
      $("html, body, .el-main").animate({ scrollTop: position.top }, 500);

      const hash = window.location.hash.split("_")[1]
      const idHash = encodeURIComponent(id.split('_')[1]);
      if (hash !== idHash) {
        // window.location.hash = id
      }
    },
    // 新增浏览量
    increaseViewNum() {
      this.timer = setTimeout(() => {
        increaseArticleViewsNum(this.articleId).then(() => { }).catch(() => { })
      }, 5000)
    },
    // 查询文章评论
    getArticleCommentList() {
      getArticleCommentList(this.articleId).then(res => {
        this.commentNum = res.data.length;
        this.commentTreeList = this.getCommentTree(res.data);
      }).catch(() => {
        this.$modal.msgError('获取文章评论失败')
      });
    },
    // 提交评论
    submit() {
      this.submitLoading = true;
      const commentData = {
        parentId: 0,
        articleId: this.article.articleId,
        content: this.comment,
        repliedUserId: this.article.userId
      }
      commentArticle(commentData).then(res => {
        this.$modal.msgSuccess('您的评论将在审核通过后展示');
        this.submitLoading = false
        // 评论成功后清空评论输入框内容
        this.comment = '';
        // 本地展示
        this.commentTreeList.unshift(res.data);
      }).catch(() => {
        this.submitLoading = false
      });
    },
    // 点击文章里的图片
    clickImage() {
      // 参数是点击的dom元素，这里获取到的是img标签
      return (element) => {
        // console.log(element)
        // console.log(element.src)
        // 先清空，否则每点击一次都会被添加到预览数组中
        // this.currentClickedImageUrlArr= [];
        // this.currentClickedImageUrlArr.push(element.src);
        this.currentClickedImageUrl = element.src;
        // console.log(this.currentClickedImageUrl)
        // 展示图片预览
        this.showViewer = true;
        this.$refs.image__preview.clickHandler();
      }
    },
    // 关闭图片预览
    closeViewer() {
      this.showViewer = false;
    },
    getLikeStatus() {
      getLikeStatus(this.articleId).then(res => {
        this.like = res.data.like;
        this.collected = res.data.collected;
        this.$refs.dianzan.style.color = res.data.like ? '#1296db' : 'darkgray';
        this.$refs.collect.style.color = res.data.collected ? '#1296db' : 'darkgray';
      }).catch();
    },
    // 点赞
    dianzan() {
      if (!this.isLogin) {
        this.$modal.msgError('登录后才能操作');
        return;
      }
      likeArticle(this.articleId).then(res => {
        if (res.data === 'like') {
          this.$refs.dianzan.style.color = '#1296db';
          // 点赞数加一
          this.likeNum++;
        } else {
          this.$refs.dianzan.style.color = 'darkgray';
          this.likeNum--;
        }
      }).catch();
    },
    collect() {
      // TODO 添加到收藏
      if (!this.isLogin) {
        this.$modal.msgError('登录后才能操作');
        return;
      }
      this.$refs.collect.style.color = '#1296db'
    },
    // 复制分享链接
    share() {
      const url = window.location.href
      if (window.clipboardData) {
        window.clipboardData.setData('text', url);
        this.$modal.msgSuccess('链接已复制，快去分享吧！')
      } else {
        (function () {
          document.oncopy = function (e) {
            e.clipboardData.setData('text', url);
            e.preventDefault();
            document.oncopy = null;
          }
        })(url);
        document.execCommand('Copy');
        this.$modal.msgSuccess('链接已复制，快去分享吧！')
      }
    },
    // 获取随机16进制颜色
    getRandomHexColor() {
      for (let i = 0; i < this.article.tagsList.length; i++) {
        let color = getRandomCoolHexColor();
        this.randomHexColors.push(color)
      }
    },
    // 将评论list转为树形结构
    getCommentTree(arr) {
      const map = {};
      const parentMap = {}
      const result = [];

      arr.forEach(item => {
        map[item.cmtId] = item
        if (item.parentId === 0) {
          parentMap[item.cmtId] = item
        }
      });

      arr.forEach(item => {
        if (item.parentId === 0) {
          result.push(item)
          if (!item.children) {
            item.children = []
          }
        } else {
          const cmtId = findParent(parentMap, map, item)
          if (cmtId) {
            parentMap[cmtId].children.push(item);
          }
        }
      });

      function findParent(parentMap, map, item) {
        console.log('step3');
        const parent = parentMap[item.parentId]
        if (parent !== undefined) {
          return parent.cmtId;
        }
        const temp = map[item.parentId]
        if (!temp) {
          return;
        }
        item.reply = temp
        return findParent(parentMap, map, temp)
      }
      return result;
    },
    /**
     * 将评论数据转为树形结构（展开对话）
     */
    getTree(arr) {
      const map = {};
      const result = [];
      arr.forEach(item => {
        map[item.cmtId] = item;
        if (item.parentId === 0) {
          result.push(item);
        }
      });
      arr.forEach(item => {
        if (item.parentId !== 0) {
          const parent = map[item.parentId];
          if (parent === undefined) {
            return
          }
          if (!parent.children) {
            parent.children = [];
          }
          parent.children.push(item);
        }
      });
      return result;
    },
  },
}
</script>

<style lang="less" scoped>
//.article {
//  width: 90%;
//  background: white;
//  padding: 10px;

.header {
  color: #474545;
}

.content {
  min-height: calc(100vh - 490px);
}

.operate {
  display: flex;
  flex-direction: row;
  margin-bottom: 10px;

  .operate-item {
    margin-right: 50px;
  }
}

.comment {
  margin: 10px 0;

  .comment-user {
    display: flex;
    align-items: center;
  }

  .comment-group {
    margin-left: 75px;

    .comment-content {
      display: block;
      //min-height: 60px;
      margin-bottom: 10px;

      .comment-operate {
        color: grey;
      }

      .sub-comment-operate {
        color: grey;
        margin-left: 50px;
      }
    }
  }
}

.size24 {
  font-size: 24px;
  color: #5f5f5f;
  margin-left: 10px;
}

//}

.recentList {
  padding: 0;
  cursor: pointer;
  margin-bottom: 10px;
  font-size: 14px;
}

.recentList:hover {
  color: #1296db;
}

.iconfont {
  font-size: 40px;
  cursor: pointer;
  color: darkgray;
}

.iconfont.icon-dianzan:hover {
  color: #1296db;
}

.iconfont.icon-collect:hover {
  color: #1296db;
}

.iconfont.icon-share:hover {
  color: #1296db;
}

.title {
  font-size: 24px;
  color: black;
  margin: 10px 0;
}

b {
  margin-right: 15px;
  ;
}

span {
  margin-right: 10px;
}

.hover {
  cursor: pointer;
}

.hover:hover {
  color: #1296db;
}

.directory-panel {
  margin-bottom: 20px;
}

.directory-panel-fixed {
  position: fixed;
  top: 70px;
  z-index: 1500;
}

.recentList-panel {
  margin-bottom: 20px;
}

.recentList-panel-fixed {
  position: fixed;
  top: 70px;
  right: 0;
  z-index: 1500;
}

.directory {
  cursor: pointer;
  color: rgba(35, 159, 255, 0.81);
}

.directory:hover {
  color: #2185d0;
}

::v-deep img {
  width: 100%;
}

.thin-divider {
  margin: 10px 0;
}

//::v-deep code {
//  word-wrap:break-word;
//  white-space:pre-wrap;
//}

::v-deep li {
  //word-break:break-all; // 对英文有效，字母间进行换行
  word-wrap: break-word; // 对英文有效，单词间换行
  white-space: pre-wrap; // 对中文生效，强制换行
}

// ↓↓↓↓↓ mavonEditor的样式：隐藏自带的目录 ↓↓↓↓↓
::v-deep .v-note-wrapper .v-note-panel .v-note-navigation-wrapper.transition {
  display: none;
}

// mavonEditor的样式：代码高亮、复制代码
::v-deep pre.hljs {
  padding: 40px 2px 12px 40px !important;
  border-radius: 5px !important;
  position: relative;
  font-size: 14px !important;
  line-height: 22px !important;
  overflow: hidden !important;

  code {
    display: block !important;
    margin: 0 10px !important;
    overflow-x: auto !important;

    &::-webkit-scrollbar {
      z-index: 11;
      width: 6px;
    }

    &::-webkit-scrollbar:horizontal {
      height: 6px;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 5px;
      width: 6px;
      background: #666;
    }

    &::-webkit-scrollbar-corner,
    &::-webkit-scrollbar-track {
      background: #1e1e1e;
    }

    &::-webkit-scrollbar-track-piece {
      background: #1e1e1e;
      width: 6px;
    }
  }

  // 行号样式
  .line-numbers-rows {
    position: absolute;
    pointer-events: none;
    top: 40px;
    bottom: 12px;
    left: 0;
    font-size: 100%;
    width: 40px;
    text-align: center;
    letter-spacing: -1px;
    border-right: 1px solid rgba(0, 0, 0, 0.66);
    user-select: none;
    counter-reset: linenumber;

    span {
      pointer-events: none;
      display: block;
      counter-increment: linenumber;

      &:before {
        content: counter(linenumber);
        color: #999;
        display: block;
        text-align: center;
      }
    }
  }

  // 代码语言
  b.name {
    position: absolute;
    top: 4px;
    right: 60px;
    z-index: 10;
    color: #999;
    pointer-events: none;
  }

  // 复制按钮样式
  .copy-btn {
    position: absolute;
    top: 4px;
    right: 4px;
    z-index: 10;
    color: white;
    background: #28C93F;
    cursor: pointer;
    border: 0;
    border-radius: 2px;
    outline: none;
  }
}

::v-deep .markdown-body pre.hljs {
  background: #23241f;
}

// 漂亮的title
::v-deep pre.hljs::after {
  height: 15px;
  width: 100px;
  margin-bottom: -7px;
  border-radius: 5px 5px 0 0;
  display: block;
  content: "";
  background: url(data:image/png;base64,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) 10px center no-repeat;
  background-size: contain;
  position: absolute;
  top: 10px;
  left: 0;
  box-sizing: border-box;
  z-index: 1;
}

::v-deep .markdown-body img {
  width: 100%;
}

// ↑↑↑↑↑ mavonEditor的样式 ↑↑↑↑↑


a {
  text-decoration: none;
  color: #333;
}

// 超过2行的内容隐藏
.text-overflow {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>
